<template>
  <canvas :ref="this.schema.graphic.ref"></canvas>
</template>

<script>
import Chart from 'chart.js';
import { abstractField } from 'vue-form-generator';
import pageServices from '@/services/page';

export default {
  mixins: [abstractField],

  async mounted() {
    this.setup();
  },
  methods: {
    async setup() {
      'setup' in this.schema.procedure && (await this.getConfig());
      await this.getData();
      this.render();
    },
    async getConfig() {
      let procedure = {
        name: this.schema.procedure.setup,
        model: {}
      };

      const { data } = await pageServices.executeProcedureAction(procedure);
      //if as lenght
      const { labels, backgroundColor, borderColor, borderWidth, type } = data.values[0];

      this.schema.graphic.type = type;
      this.schema.graphic.data.labels = labels.split(';');
      this.schema.graphic.data.datasets[0].backgroundColor = backgroundColor.split(';');
      this.schema.graphic.data.datasets[0].borderColor = borderColor.split(';');
      this.schema.graphic.data.datasets[0].borderWidth = borderWidth;
    },
    async getData() {
      let procedure = {
        name: this.schema.procedure.data,
        model: {}
      };
      const { data } = await pageServices.executeProcedureAction(procedure);

      this.schema.graphic.data.datasets[0].data = data.values.map(item => item.data);
    },
    render() {
      const chart = this.$refs[this.schema.graphic.ref];
      const ctx = chart.getContext('2d');

      new Chart(ctx, {
        type: this.schema.graphic.type,
        data: this.schema.graphic.data,
        options: this.schema.graphic.options
      });
    }
  }
};
</script>
